<div style="position: absolute;top: 0;left: 0;width: 100%;">
  <nav class="navbar navbar-expand navbar-color navbar-light" style="margin-left: 0px;height: 70px; padding-left: 0;">
    <a [routerLink]="['/']">
    <img
        src={{logoUrl}}
        alt="AdminLTE Logo"
        class="brand-image"
        style="margin-left: 20px;"
      /></a>
  </nav>
</div>

<div class="login-box" style="margin-top: 80px;">
  <div class="login-logo">
    <!-- <i class="fas fa-exclamation-triangle circle-icon" style='font-size:30px; color: white'></i> -->
    <img src="assets/img/グループ 40.svg"/>
  </div>
  <div class="login-logo">
    <p class="reques-class" style="font-size: 20px; color:#F85F58;">{{ 'WARNING.TITLE_2' | translate }}</p>
  </div>
  <div class="text-center" style="margin-top: 40px;">
    <p class="reques-class" style="font-size: 16px;color: #3E3E3E;">{{ 'WARNING.WARNING_TXT_3' | translate }}</p>
  </div>  
</div>